export default "__VITE_ASSET__a6rq$vEY__"